import React from 'react';
import { EventCalendarModel } from '../../../model/events';
import { StyleEventTitle, StyleEventText } from '../../core/Calendar';

/**
 * Wrapper to show the info of an event inside the calendar
 * @param {EventCalendarModel} event - All the infor about the event. Obtained by Redux
 */
const Event = ({ event }) => {
  const { status } = event;
  return (
    <StyleEventTitle status={status}>
      <StyleEventText>{event.title}</StyleEventText>
    </StyleEventTitle>
  );
};

Event.propTypes = {
  event: EventCalendarModel
};

export default Event;
